import { render } from "./ExternalLinkIcon.vue?vue&type=template&id=9b530188"
import script from "./ExternalLinkIcon.vue?vue&type=script&lang=js"
export * from "./ExternalLinkIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__